import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import { initActionTableHeaders } from "./components/ActionList";
import avatar from "../../../assets/img/noAvatar.png";
import Dropdown from "../../components/Dropdown";
import TextInput from "../../components/TextInput";
import dayjs from "dayjs";
import ConfirmPopup from "../../components/ConfirmPopup";
import UnsaveConfirmPopup from "./components/UnsaveConfirmPopup";
import useClickOutside from "../../utils/useOutsideClick";
import CompanyHeader from "components/CompanyHeader";
import CompanySideMenu from "components/CompanySideMenu";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {formatDate, formatDateTime, formatName} from "utils/format";
import { addActionItems, updateActionItems, deleteActionItem, getActionDetail,
  getListOptionsRelatedAction, setLoadingGetActionItem, setActionName,
  setActionStatus } from "reducers/action";
import CustomToast from "components/CustomToast";
import {useSnackbar} from "notistack";
import { ACTION_TYPE, MESSAGE_SEND_FROM, STAFF_TYPE } from '../../constants/index';
import ReturnButton from "../../components/ReturnButton";
import CustomIconButton from "../../components/CustomIconButton";
import CustomButton from "../../components/CustomButton";
import {LoadingIcon} from "components/Icons";
import NotFoundPage from "../../pages/NotFoundPage";
import Copyright from "../../components/Copyright";
import TalentDetailPanel from "../talent/components/TalentDetailPanel";
import { getDetailTalent, setSelectedTalent, setCancelTalentStatus, setTalentTagsSelected } from "reducers/companyTalent";
import {setOpenDetailTalentPanel} from 'reducers/companyHome'
import i18n from 'i18next';
import { setIsFormDirty, setShowLeaveConfirm } from "reducers/app";

const actionDetailTableHeaders = [{ title: "", isSort: false, },
  { title: "ステータス", isSort: false, }, { title: "担当者", isSort: false, },
  { title: "連絡事項", isSort: false, }, { title: "", isSort: false, }, ];

const ActionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const { actionSelected, actionItems, optionsRelatedAction, actionStatus, actionName, loadingGetActionItem,
    isSuccess, apiMessage
   } = useSelector((state: any) => state.action);
  const { cancelTalentStatus } = useSelector((state: any) => state.companyTalent);
  const {isFormDirty, showLeaveConfirm, isNavigatingAway} = useSelector((state: any) => state.app);
  const isOpenDetailTalentPanel = useSelector((state: any) => state.companyHome.isOpenDetailTalentPanel);
  const [actionCreating, setActionCreating] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [content, setContent] = useState("");
  const [status, setStatus] = useState(null);
  const [staff, setStaff] = useState(null);
  const [itemDelete, setItemDelete] = useState({id: ''});
  const [isEdit, setIsEdit] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState({id: null, name: ''});
  const [staffUpdate, setStaffUpdate] = useState({id: null, name: ''});
  const [contentUpdate, setContentUpdate] = useState("");
  const [idItemEdit, setIdItemEdit] = useState(null);
  const ref = useRef(null);
  const editRowRef = useRef(null);
  const dropdownAddStatusRef = useRef(null);
  const dropdownAddStaffRef = useRef(null);
  const dropdownEditStatusRef = useRef(null);
  const dropdownEditStaffRef = useRef(null);
  const [destinationUrl, setDestinationUrl] = useState("");

  useEffect(() => {
    if(optionsRelatedAction.action_status?.length == 0 || optionsRelatedAction.staffs?.length == 0) {
      dispatch(getListOptionsRelatedAction(""));
    }

    // Get action detail
    if (!id) {
      navigate("/company/login");
      return;
    }
    dispatch(setLoadingGetActionItem(true));
    dispatch(getActionDetail({ id: parseInt(id) }));
    dispatch(setOpenDetailTalentPanel(false));
    return () => dispatch(setIsFormDirty(false));
  }, []);

  useEffect(() => {
    if (cancelTalentStatus === 'fulfilled') {
      dispatch(getActionDetail({ id: parseInt(id) }));
      dispatch(setCancelTalentStatus("idle"));
    }
  }, [cancelTalentStatus]);

  const markDirty = () => {
    if(!isFormDirty) {
      dispatch(setIsFormDirty(true));
    }
  }

  const showToast = (title: string, message: string, variant: string) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (<CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} />),
    });
  };

  // Show toast
  useEffect(() => {
    if (actionStatus == 'fulfilled') {
      switch(actionName) {
          case 'addActionItems':
            if(!isSuccess) {
              showToast('メッセージ', apiMessage, "error");
            } else {
              showToast('メッセージ', i18n.t('MSG_ACTION_ADD_SUCCESS'), "success");
              sessionStorage.setItem('isResetPageActionList', 'true')
            }
            setContent("");
            setStatus({id: null, name: ''});
            setStaff({id: null, name: ''});
            setActionCreating(false);
            dispatch(getActionDetail({ id: Number(id) }));
            break;
          case 'updateActionItems':
            if(!isSuccess) {
              showToast('メッセージ', apiMessage, "error");
            } else {
              showToast('メッセージ', i18n.t('MSG_ACTION_UPDATE_SUCCESS'), "success");
            }
            setContentUpdate("");
            setStatusUpdate({id: null, name: ''});
            setStaffUpdate({id: null, name: ''});
            setIsEdit(false);
            dispatch(getActionDetail({ id: Number(id) }));
            break;
          case 'deleteActionItem':
            if(!isSuccess) {
              showToast('メッセージ', apiMessage, "error");
            } else {
              showToast('メッセージ', i18n.t('MSG_GLOBAL_DELETE_SUCCESS'), "success");
            }
            dispatch(getActionDetail({ id: Number(id) }));
            break;
          default:
            break;
        }
      dispatch(setActionName(""));
      dispatch(setActionStatus("idle"));
    }
  }, [actionStatus, actionName]);

  const validateAddUpdate = (status: any, staff: any, content: any) => {
    let result = true
    if(!status || !status.id) {
      showToast('メッセージ', "ステータスは必須です。", "error");
      result = false
    }
    if(!staff || !staff.id) {
      showToast('メッセージ', "担当者は必須です。", "error");
      result = false
    }
    return result
  }

  const handleCreateActionItem = () => {
    // Validate
    const isValid = validateAddUpdate(status, staff, content)
    if(!isValid) { return }

    const data = {
      staff_id: staff?.id,
      status_id: status?.id,
      content: content
    }
    dispatch(addActionItems({ id: Number(id), requestBody: data }));
    dispatch(setIsFormDirty(false));
  };

  const handleUpdateActionItem = () => {
    // Validate
    const isValid = validateAddUpdate(statusUpdate, staffUpdate, contentUpdate)
    if(!isValid) { return }
    const data = {
      staff_id: staffUpdate?.id,
      status_id: statusUpdate?.id,
      content: contentUpdate
    }
    dispatch(updateActionItems({ id: Number(idItemEdit), requestBody: data }));
    dispatch(setIsFormDirty(false));
  };

  const handleDeleteActionItem = (actionItem: any) => {
    setItemDelete(actionItem)
    setIsConfirmOpen(true);
  };

  const confirmDeleteActionItem = () => {
    dispatch(deleteActionItem({ id: parseInt(itemDelete?.id) }));
    setIsConfirmOpen(false);
  };

  const getOptionById = (id: any, items: any) => {
    for(const item of items) {
      if(item.id == id) {
        return item
      }
    }
    return null
  };

  const handleEditItem = (actionItem: any) => {
    if (isEdit || actionCreating || !actionSelected?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL) {
      return
    }
    const statusOption = getOptionById(actionItem.status?.id, optionsRelatedAction.action_status)
    setStatusUpdate(statusOption)

    const staffOption = getOptionById(actionItem.staff?.id, optionsRelatedAction.staffs)
    setStaffUpdate(staffOption)

    setContentUpdate(actionItem.content)
    setIsEdit(true)
    setActionCreating(false)
    setIdItemEdit(actionItem.id)
  };

  //Access to this page is denied
  if(!actionSelected.id) {
    if(actionName == "getActionDetail" && actionStatus == "rejected") return <NotFoundPage />;
    return null;
  }

  const goToTalentDetail = (item: any) => {
    dispatch(setSelectedTalent({}));
    dispatch(setTalentTagsSelected([]));
    if (!isOpenDetailTalentPanel) {
      dispatch(setOpenDetailTalentPanel(true));
    }
    dispatch(getDetailTalent({ id: item.id }));
    
  }
  
  const handleActionCreatingOpen = () => {
    if(isEdit && isFormDirty) {
      dispatch(setShowLeaveConfirm(true));
      return;
    }
    setActionCreating(true);
    setIsEdit(false);
    setIdItemEdit(null);
  }

  const handleCancelActionCreation = () => {
    setActionCreating(false);
    setContent("");
    setStatus({id: null, name: ''});
    setStaff({id: null, name: ''});
    dispatch(setIsFormDirty(false))
  }

  const handleReturnPreviousPage = () => {
    if(isFormDirty) {
      setDestinationUrl('/company/action');
      dispatch(setShowLeaveConfirm(true));
    } else {
      navigate('/company/action', { state: { isFromDetail: true } });
    }
  }

  const handleGoToJobDetailPage = (actionSelected: any) => {
    if(isFormDirty) {
      setDestinationUrl("/company/job/detail/" + actionSelected?.job?.id);
      dispatch(setShowLeaveConfirm(true));
    } else {
      navigate("/company/job/detail/" + actionSelected?.job?.id)
    }
  }

  const handleResetForm = () => {
    setContent("");
    setStatus({id: null, name: ''});
    setStaff({id: null, name: ''});
    setContentUpdate("");
    setStatusUpdate({id: null, name: ''});
    setStaffUpdate({id: null, name: ''});
    setIsEdit(false);
    setActionCreating(false);
    dispatch(setShowLeaveConfirm(false));
    dispatch(setIsFormDirty(false));
    if(destinationUrl) {
      navigate(destinationUrl, { state: { isFromDetail: true } });
    } else {
      navigate('/company/action', { state: { isFromDetail: true } });
    }
  }

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-4 flex items-center gap-4">
            <ReturnButton onClick={handleReturnPreviousPage} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              選考状況　{formatDate(actionSelected?.created_at)} {formatName(actionSelected.talent?.first_name, actionSelected.talent?.last_name)}
            </h3>
          </div>

          <CustomButton onClick={handleActionCreatingOpen} disabled={actionCreating || !actionSelected.is_active || staffInfo?.type == STAFF_TYPE.GENERAL} type="button" size="sm">
            選考状況を追加
          </CustomButton>

          <div className="bg-white z-10 relative rounded-lg mt-6">
            <table className="table-auto w-full z-10">
              <thead className="border-b alu-border px-4 py-2 bg-[#E9E9E9]">
                <tr>
                  {initActionTableHeaders.map((header, idx) => (
                    <th key={idx} className={`px-2 py-2 text-left ${header.width}`}>
                      <div className="flex items-center">
                        <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">
                          {header.title}
                        </p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="alu-panel-box-shadow bg-white">
                  <td className="px-2 py-2 text-center w-[2.25rem]">
                    <div className="flex items-center justify-center">
                    <CustomIconButton
                      size="sm"
                      variant="icononly"
                      onClick={() => navigate('/company/action', { state: { isFromDetail: true } })}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_16829_5202)">
                          <path
                            d="M10.5 16.5L15.5 11.5L10.5 6.5L10.5 16.5Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16829_5202">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </CustomIconButton>
                    </div>
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[5rem] max-w-[8rem]">
                    {actionSelected.type_str}
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[9rem] max-w-[11rem]">
                    <div className="flex items-center gap-2 cursor-pointer"  onClick={() => goToTalentDetail({id: actionSelected?.talent_company_id})}>
                      <img src={actionSelected.talent?.avatar ? actionSelected.talent?.avatar : avatar} alt="avt" className="w-8 h-8 rounded-full object-cover" />
                      <p className="text-sm alu-text-base-2">{formatName(actionSelected.talent?.first_name, actionSelected.talent?.last_name)}</p>
                      {!actionSelected?.is_active ? "（退会済み）" : ""}
                    </div>
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 w-auto min-w-[8rem] max-w-[11rem]">
                    {formatDateTime(actionSelected?.created_at)}
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 w-[8rem]">
                    <span className="py-[0.125rem] px-2 rounded-2xl bg-[#E0E0E0] alu-text-base-2">
                      {actionSelected?.is_active ? actionSelected.status_str : '退会済み'}
                    </span>
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[7rem] max-w-[9rem]">{formatName(actionSelected.main_staff?.first_name, actionSelected.main_staff?.last_name)}</td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[12rem]">
                    <p className="max-w-fit line-clamp-1 underline underline-offset-2 hover:text-[#FF861A] hover:cursor-pointer" 
                      onClick={() => handleGoToJobDetailPage(actionSelected)}>
                      {actionSelected.job?.title}
                    </p>
                  </td>
                  <td className="px-2 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[8rem] max-w-[9rem]">{actionSelected.job?.occupation_1?.name}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="ml-8 bg-white rounded-b-lg z-5 relative">
            <table className="table-auto w-full z-5">
              <thead className="border-b alu-border px-4 py-2">
                <tr>
                  {actionDetailTableHeaders.map((header, idx) => (
                    <th key={idx} className="px-4 py-2 text-left">
                      <div className="flex items-center">
                        <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">{header.title}</p>
                        {header.isSort && (
                          <button>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ><g clipPath="url(#clip0_8574_176)"><path d="M7 10L12 15L17 10H7Z" fill="#808080" /></g><defs><clipPath id="clip0_8574_176"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>
                          </button>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {actionCreating && (
                  <tr className="border border-[#FF861A]" ref={ref} >
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                      {dayjs(new Date()).format("YYYY/MM/DD")}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125]">
                      <Dropdown customRef={dropdownAddStatusRef} placeholder={"ステータス"} options={optionsRelatedAction?.action_status}
                        value={status} onChange={(value: any) => {markDirty(); setStatus(value);}} />
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125]">
                      <Dropdown customRef={dropdownAddStaffRef} placeholder={"担当者"} options={optionsRelatedAction?.staffs}
                        value={staff} onChange={(value: any) => {markDirty(); setStaff(value);}} />
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125]">
                      <TextInput placeholder={"入力してください"} size="md" value={content}
                        onChange={(e: any) => {markDirty(); setContent(e.target.value);}} />
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                      <div className="flex items-center gap-3 justify-end">
                        <CustomButton onClick={handleCreateActionItem} type="button" size="md">
                          保存
                        </CustomButton>
                        <CustomButton onClick={handleCancelActionCreation} variant="text">
                          キャンセル
                        </CustomButton>
                      </div>
                    </td>
                  </tr>
                )}
                {actionItems.map((item: any, idx: any) => (
                  <tr key={idx} className={`
                    ${
                      !(idItemEdit === item.id && isEdit)
                        ? `border-t border-t-[#E0E0E0]  ${actionSelected?.is_active && staffInfo?.type != STAFF_TYPE.GENERAL ? "hover:bg-[#fff3e5] cursor-pointer" : ""}`
                        : "outline outline-1 outline-[#FF861A]"
                    }`}
                    ref={idItemEdit === item.id ? editRowRef : null}>
                    <td onClick={() => handleEditItem(item)}
                      className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 w-[10rem]">
                      {formatDate(item?.created_at)}
                    </td>
                    <td onClick={() => handleEditItem(item)} className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] w-[12.5rem]">
                      { isEdit && idItemEdit == item.id ? (
                        <Dropdown customRef={dropdownEditStatusRef} placeholder={"ステータス"} options={optionsRelatedAction?.action_status}
                          value={statusUpdate} onChange={(value: any) => {markDirty(); setStatusUpdate(value);}} />
                        ) : (
                          <span className="block text-center py-[0.125rem] px-2 rounded-2xl bg-[#E0E0E0] alu-text-base-2">
                            {item.status_str}
                          </span>
                        )
                      }
                    </td>
                    <td onClick={() => handleEditItem(item)} className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] w-[13rem]">
                      { isEdit && idItemEdit == item.id ? (
                        <Dropdown customRef={dropdownEditStaffRef} placeholder={"担当者を選択"} options={optionsRelatedAction?.staffs}
                                  value={staffUpdate} onChange={(value: any) => {markDirty(); setStaffUpdate(value);}} />
                        ) : (
                          <p className="alu-text-base-2">{formatName(item.staff?.first_name, item.staff?.last_name)}</p>
                        )
                      }
                    </td>
                    <td onClick={() => handleEditItem(item)} className="px-4 py-2 text-left font-normal text-sm leading-[1.3125]">
                      {isEdit && idItemEdit == item.id ? (
                        <TextInput placeholder={"入力してください"} size="md" value={contentUpdate}
                          onChange={(e: any) => {markDirty(); setContentUpdate(e.target.value);}} />
                      ) : (
                        <p className="alu-text-base-2">{item.content}</p>
                      )
                      }
                    </td>
                    <td className="px-4 py-2 text-right font-normal text-sm leading-[1.3125] w-[16rem]">
                      {isEdit && idItemEdit == item.id ? (
                          <div className="flex items-center gap-3 justify-end">
                            <CustomButton onClick={handleUpdateActionItem} type="button" size="md">
                              保存
                            </CustomButton>
                            <CustomButton onClick={() => {setIsEdit(false); dispatch(setIsFormDirty(false))}} variant="text">
                              キャンセル
                            </CustomButton>
                          </div>
                        ) : (
                          <>
                          {idx != actionItems.length - 1 && actionSelected?.is_active && 
                            <CustomButton customStyle="ml-auto" onClick={() => handleDeleteActionItem(item)} variant="text" 
                              disabled={staffInfo?.type == STAFF_TYPE.GENERAL}>
                              削除
                            </CustomButton>
                          }
                          </>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {loadingGetActionItem && (
              <div className="flex items-center justify-center"><LoadingIcon/></div>
            )}
          </div>
        </div>
      </div>
      {isConfirmOpen && (
        <ConfirmPopup open={isConfirmOpen}
          onClose={() => setIsConfirmOpen(false)}
          confirmContent={"このアクションの選考状況を削除しますか?"}
          onConfirm={confirmDeleteActionItem}
          type="delete"
        />
      )}
      {showLeaveConfirm && !isNavigatingAway && (
        <UnsaveConfirmPopup
          open={showLeaveConfirm}
          onClose={() => dispatch(setShowLeaveConfirm(false))}
          confirmContent="編集中の内容を保存せずに終了しますか？"
          onOtherAction={() => handleResetForm()}
        />
      )}
      <Copyright view="company" />
      {isOpenDetailTalentPanel && <div className="fixed right-2 top-2 bottom-2 z-[999]"><TalentDetailPanel open={isOpenDetailTalentPanel} onClose={() => {}} onScreen={MESSAGE_SEND_FROM.ACTION} /></div>}
    </>
  );
};

export default ActionDetail;
